import buildItemMetrics from './buildItemMetrics';
import getMetrics from './getMetrics';

export default function addTreeItemMetrics({
  designEntities,
  entityLevelOnly,
  entity,
  entities,
  entitySet,
  property = 'metrics',
  treeItem,
}) {
  const metrics = {};

  designEntities.forEach((design) => {
    // Only the designs that share this tree path aggregate here. Every other
    // design keeps its existing or empty metrics so each item carries every
    // design, and aggregates along its own path instead.
    if (design.path !== entities) {
      metrics[design.id] = treeItem?.[property]?.[design.id] ?? getMetrics();
      return;
    }

    metrics[design.id] = buildItemMetrics({
      designId: design.id,
      entities: design.entities,
      entity,
      entityLevelOnly,
      entitySet,
      property,
      treeItem,
    });
  });

  return metrics;
}
